import { Program } from '@citruscamps/citrus-client'
import { DateTime } from 'luxon'
import React from 'react'
import { ShowMoreButton } from '../../../../../components/ShowMoreButton/ShowMoreButton'
import { DefaultDetailsPagination } from '../../../../../constants/pagination'
import { LoadingAttendees } from '../../../../Attendees/pages/ManageAttendees/components/LoadingAttendees'
import { useFetchInfiniteAttendees } from '../../../../Attendees/pages/ManageAttendees/hooks/useFetchAttendees'
import { CelebrationRow } from './CelebrationRow'

interface IProps {
  program: Program
}

export const CelebrationsList = ({ program }: IProps) => {
  const {
    data: attendees,
    isFetchingNextPage,
    isLoading,
    pagination,
    fetchNextPage,
  } = useFetchInfiniteAttendees({
    programId: program?.id,
    fetchProps: {
      sort: 'celebrations',
      order: 'ASC',
      query: {
        is_archived: false,
        birthday: {
          lte: DateTime.local().endOf('day').plus({ days: 5 }).toJSDate(),
          gte: DateTime.local().startOf('day').toJSDate(),
        },
      },
    },
    pagination: DefaultDetailsPagination,
    isEnabled: !!program?.id,
  })
  return (
    <div className="mt-3">
      <div className="d-flex mt-lg-1 mt-3">
        <h5 className="my-auto text-center">Celebrations</h5>
        <div className="text-body-secondary my-auto ms-2 text-center">
          {typeof pagination.total !== 'undefined' ? `(${pagination.total})` : '\u00A0'}
        </div>
      </div>

      {(() => {
        if (isLoading && attendees.length === 0) {
          return <LoadingAttendees {...pagination} compact={true} />
        }
        if (attendees.length === 0) {
          return (
            <div className="text-body-secondary text-center">
              <hr className="mt-2" />
              <p className="mb-xl-5">There are no upcoming celebrations at this time.</p>
            </div>
          )
        }
        return (
          <>
            <hr className="mt-2" />
            <div className="d-flex list-group list-group-flush list-group-activity">
              {attendees.map((attendee, i) => (
                <CelebrationRow attendee={attendee} key={attendee.id} />
              ))}
              {isLoading || isFetchingNextPage ? (
                Array.from({ length: 3 })
                  .fill(null)
                  .map((_, i) => `loading-row-${i}`)
                  .map((key) => (
                    <div key={key} className="list-group-item">
                      <div className="row g-0 mb-4">
                        <div className="me-5">
                          <div>
                            <div className="row-img-square animate"></div>
                          </div>
                        </div>
                        <div className="col" style={{ height: '80px' }}>
                          <div className="animate mx-3 rounded" style={{ height: '55px' }} />
                        </div>
                      </div>
                    </div>
                  ))
              ) : (
                <ShowMoreButton
                  {...pagination}
                  onChange={(pageParam) => fetchNextPage({ pageParam })}
                />
              )}
            </div>
          </>
        )
      })()}
    </div>
  )
}
